import React, { useState, Fragment } from 'react'
import { useSprings, animated, to as interpolate } from 'react-spring'
import { useDrag } from 'react-use-gesture'

const createMarkup = text => {
  return { __html: text }
}

// These two are just helpers, they curate spring data, values that are later being interpolated into css
const to = i => ({
  x: 0,
  y: i * 25,
  scale: 1,
  // rot: -10 + Math.random() * 20,
  rot: 0,
  delay: i * 100
})
const from = i => ({ x: 0, rot: 0, scale: 1, y: -1000 })
// This is being used down there in the view, it interpolates rotation and scale into a css transform
const trans = (r, s) =>
  `perspective(1500px) rotateX(0deg) rotateY(${
    r / 10
  }deg) rotateZ(${r}deg) scale(${s})`

const Supplementary = ({ cards }) => {
  const [gone] = useState(() => new Set()) // The set flags all the cards that are flicked out
  const [index, setIndex] = useState(0)
  const [props, set] = useSprings(cards.length, i => ({
    ...to(i),
    from: from(i)
  })) // Create a bunch of springs using the helpers above
  // Create a gesture, we're interested in down-state, delta (current-pos - click-pos), direction and velocity
  const bind = useDrag(
    ({
      args: [index],
      down,
      movement: [mx],
      distance,
      direction: [xDir],
      velocity
    }) => {
      const trigger = velocity > 0 // If you flick hard enough it should trigger the card to fly out
      const dir = xDir < 0 ? -1 : 1 // Direction should either point left or right
      if (!down && trigger) {
        setIndex(index => (index === cards.length - 1 ? 0 : index + 1))
        gone.add(index) // If button/finger's up and trigger velocity is reached, we flag the card ready to fly out
      }
      set(i => {
        if (index !== i) return // We're only interested in changing spring-data for the current spring
        const isGone = gone.has(index)

        const x = isGone ? (200 + window.innerWidth) * dir : down ? mx : 0 // When a card is gone it flys out left or right, otherwise goes back to zero
        const rot = mx / 100 + (isGone ? dir * 10 * velocity : 0) // How much the card tilts, flicking it harder makes it rotate faster
        const scale = down ? 1 : 1 // Active cards lift up a bit
        //const blur = gone.size != cards.length - i - 1;

        return {
          x,
          rot,
          scale,
          delay: undefined,
          config: { friction: 50, tension: down ? 800 : isGone ? 200 : 500 }
        }
      })
      if (!down && gone.size === cards.length)
        setTimeout(() => gone.clear() || set(i => to(i)), 600)
    }
  )
  // Now we're just mapping the animated values to our view, that's it. Btw, this component only renders once. :-)
  return (
    <Fragment>
      <div className='cards-container'>
        {props.map(({ x, y, rot, scale }, i) => {
          return (
            <animated.div className={`card-container`} key={i} style={{ x, y }}>
              {/* This is the card itself, we're binding our gesture to it (and inject its index so we know which is which) */}
              <animated.div
                {...bind(i)}
                className='card'
                style={{
                  transform: interpolate([rot, scale], trans)
                }}>
                <div className='chart-title card-title noselect'>
                  {cards[i].title}
                </div>
                <div
                  className='chart-caption noselect'
                  dangerouslySetInnerHTML={createMarkup(
                    cards[i].caption
                  )}></div>
                <div className='chart-subtitle card-subtitle noselect'>
                  {cards[i].subtitle}
                </div>
                <div id={props.id} className='supplementary-chart-wrapper'>
                  <img
                    alt={cards[i].subtitle}
                    src={require(`../../img/${cards[i].url}`).default}
                    draggable='false'></img>
                </div>
                {cards[i].note && (
                  <div className='chart-note noselect'>{cards[i].note}</div>
                )}
                <div
                  className='chart-source noselect'
                  dangerouslySetInnerHTML={createMarkup(cards[i].source)}></div>
              </animated.div>
            </animated.div>
          )
        })}
      </div>
      <div className='progression-dots'>
        {cards.map((d, i) => (
          <div
            key={`dot-${i}`}
            className={`progression-dot${index === i ? ' active' : ''}`}></div>
        ))}
      </div>
    </Fragment>
  )
}

export default Supplementary
